<template>
  <div class="page-body">
    <b-card class="content-card">
      <div fluid>
        <div class="appbar-container">
          <h3 class="appbar-container__title">لیست شروط جایره</h3>
        </div>
        <b-skeleton-table v-if="loading" :rows="5" :columns="5" :table-props="{ bordered: true, striped: true }">
        </b-skeleton-table>
        <b-table
          class="reward-table"
          v-else
          :items="items"
          :fields="fields"
          empty-text="موردی یافت نشد"
          stacked="md"
          show-empty
          small
        >
          <template #cell(name)="row">
            <div class="text-center">
              {{ row.item.name }}
            </div>
          </template>

        </b-table>
      </div>
    </b-card>
    <b-row no-gutters>
      <b-col sm="12" class="my-1 d-flex justify-content-center">
        <BasePagination
          :showNext="showNext"
          :showPrev="filters.page_number !== 0"
          @onClick="handlePaginationClick"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>

const actionTypeValues = {
  FIXED: "FIXED",
  PERCENTAGE_OF_LAST: "PERCENTAGE_OF_LAST",
  PERCENTAGE_OF_HIGHEST: "PERCENTAGE_OF_HIGHEST",
  PERCENTAGE_OF_EACH: "PERCENTAGE_OF_EACH",
  PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS: "PERCENTAGE_OF_EACH_CRYPTO_ON_TOKENS",
  PERCENTAGE_OF_TOTAL: "PERCENTAGE_OF_TOTAL",
  PERCENTAGE_OF_TOTAL_BALANCE: "PERCENTAGE_OF_TOTAL_BALANCE",
  PERCENTAGE_OF_TOKEN_BALANCE: "PERCENTAGE_OF_TOKEN_BALANCE",
};
const percentageOfEachValues = {
  ALL: "ALL",
  TRADE: "TRADE",
  TRANSACTION: "TRANSACTION",
  TRANSACTION_CRYPTO: "TRANSACTION_CRYPTO",
  TRANSACTION_CRYPTO_TRADE: "TRANSACTION_CRYPTO_TRADE",
  TRANSACTION_FIAT: "TRANSACTION_FIAT",
  TRANSACTION_CRYPTO_DEPOSIT: "TRANSACTION_CRYPTO_DEPOSIT",
  TRANSACTION_CRYPTO_WITHDRAW: "TRANSACTION_CRYPTO_WITHDRAW",
  TRANSACTION_FIAT_DEPOSIT: "TRANSACTION_FIAT_DEPOSIT",
  TRANSACTION_FIAT_WITHDRAW: "TRANSACTION_FIAT_WITHDRAW",
};
const percentageOfEachCryptoValues = {
  ALL: "ALL",
  TRADE: "TRADE",
  TRANSACTION: "TRANSACTION",
  TRANSACTION_CRYPTO_DEPOSIT: "TRANSACTION_CRYPTO_DEPOSIT",
  TRANSACTION_CRYPTO_WITHDRAW: "TRANSACTION_CRYPTO_WITHDRAW",
};
const timeTypeValues = {
  EVERYDAY_FOR: "EVERYDAY_FOR",
  EVERYDAY_FROM_TO: "EVERYDAY_FROM_TO",
  OVER_ANY_RANGE_OF: "OVER_ANY_RANGE_OF",
  OVER_FROM_TO: "OVER_FROM_TO",
  ANY_DAY_FROM_TO: "ANY_DAY_FROM_TO",
  AT: "AT",
  ANYTIME: "ANYTIME",
};
const typeValues = {
  SIGN_IN: "SIGN_IN",
  SIGN_UP: "SIGN_UP",
  REFER: "REFER",
  GOOGLE_AUTH: "GOOGLE_AUTH",
  DEPOSIT_TOMAN: "DEPOSIT_TOMAN",
  WITHDRAW_TOMAN: "WITHDRAW_TOMAN",
  TRADE: "TRADE",
  DEPOSIT_CRYPTO: "DEPOSIT_CRYPTO",
  WITHDRAW_CRYPTO: "WITHDRAW_CRYPTO",
  TRANSACTION_TRADE: "TRANSACTION_TRADE",
  CRYPTO_TRANSACTION_TRADE: "CRYPTO_TRANSACTION_TRADE",
  CRYPTO_TRANSACTION: "CRYPTO_TRANSACTION",
  TOMAN_TRANSACTION: "TOMAN_TRANSACTION",
};


import {fetchAll, fetchRewardConditions, updateReward} from "@/httpservices/Reward";
import BasePagination from "@/components/BasePagination.vue";

export default {
  name: "RewardConditionsList",

  data() {
    return {
      loading: true,
      filters: {
        page_size: 10,
        page_number: 0,
      },
      items: [],
      fields: [
        {
          key: "type",
          label: "نوع",
          sortable: false,
          class: "text-center",
        },
        {
          key: "done_type",
          label: "شکل انجام",
          sortable: false,
          class: "text-center",
        },
        {
          key: "repeat",
          label: "تکرار",
          sortable: false,
          class: "text-center",
        },
        {
          key: "reward_name",
          label: "نام ",
          sortable: false,
          class: "text-center",
        },
      ],
      actionTypeOptions: [
        {
          value: "DONE",
          text: "انجام شده",
        },
        {
          value: "DONE_ON_TOKENS",
          text: "انجام شده روی رمزارز های مشخص شده",
        },
        {
          value: "BE_AT_LEAST",
          text: "حداقل مقدار",
        },
        {
          value: "DONE_COUNT_AT_LEAST",
          text: "حداقل دفعات",
        },
        {
          value: "DONE_COUNT_AT_LEAST_EACH_ONE_BE_AT_LEAST",
          text: "حداقل دفعات برای هر",
        },
        {
          value: "DONE_SUM_AT_LEAST",
          text: "حداقل مجموع",
        },
        {
          value: "BE_AT_LEAST_ON_TOKENS",
          text: "حداقل  مقدار برای رمزارز های مشخص",
        },
        {
          value: "DONE_COUNT_AT_LEAST_FOR_TOKENS",
          text: "حداقل تعداد دفعات برای رمزارز های مشخص",
        },
        {
          value: "DONE_SUM_AT_LEAST_FOR_TOKENS",
          text: "حداقل مجموع برای رمزارز های مشخص",
        },
        {
          value: "DONE_COUNT_AT_LEAST_EACH_ONE_BE_AT_LEAST_ON_TOKENS",
          text: "حداقل تعداد دفعات برای هر رمزارز مشخص",
        },
      ],
      percentageOfEachOptions: [
        {
          value: percentageOfEachValues.ALL,
          text: "همه",
        },
        {
          value: percentageOfEachValues.TRADE,
          text: "ترید",
        },
        {
          value: percentageOfEachValues.TRANSACTION,
          text: "تراکنش",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO,
          text: "تراکنش رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_TRADE,
          text: "تراکنش و ترید رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT,
          text: "تراکنش تومانی",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_DEPOSIT,
          text: "واریز رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_CRYPTO_WITHDRAW,
          text: "برداشت رمزارز",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT_DEPOSIT,
          text: "واریز تومان",
        },
        {
          value: percentageOfEachValues.TRANSACTION_FIAT_WITHDRAW,
          text: "برداشت تومان",
        },
      ],
      percentageOfEachCryptoOptions: [
        {
          value: percentageOfEachCryptoValues.ALL,
          text: "همه"
        },
        {
          value: percentageOfEachCryptoValues.TRADE,
          text: "ترید"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION,
          text: "تراکنش"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION_CRYPTO_DEPOSIT,
          text: "واریز رمزارز"
        },
        {
          value: percentageOfEachCryptoValues.TRANSACTION_CRYPTO_WITHDRAW,
          text: "برداشت رمزارز"
        },
      ],
      timeTypeOptions: [
        {
          value: timeTypeValues.EVERYDAY_FOR,
          text: "روز متوالی"
        },
        {
          value: timeTypeValues.EVERYDAY_FROM_TO,
          text: "هر روز از"
        },
        {
          value: timeTypeValues.OVER_ANY_RANGE_OF,
          text: "در هر بازه زمانی"
        },
        {
          value: timeTypeValues.OVER_FROM_TO,
          text: "در یک بازه زمانی"
        },
        {
          value: timeTypeValues.ANY_DAY_FROM_TO,
          text: "هر روز در یک بازه زمانی"
        },
        {
          value: timeTypeValues.AT,
          text: "در تاریخ"
        },
        {
          value: timeTypeValues.ANYTIME,
          text: "هر زمانی"
        },
      ],
      typeOptions: [
        {
          value: "SIGN_IN",
          text: "ورود"
        },
        {
          value: "SIGN_UP",
          text: "ثبت نام"
        },
        {
          value: "REFER",
          text: "معرفی"
        },
        {
          value: "GOOGLE_AUTH",
          text: "فعال کردن رمز دو مرحله ای گوگل"
        },
        {
          value: "DEPOSIT_TOMAN",
          text: "واریز تومان"
        },
        {
          value: "WITHDRAW_TOMAN",
          text: "برداشت تومان"
        },
        {
          value: "TRADE",
          text: "ترید"
        },
        {
          value: "DEPOSIT_CRYPTO",
          text: "واریز رمزارز"
        },
        {
          value: "WITHDRAW_CRYPTO",
          text: "برداشت رمزارز"
        },
        {
          value: "TRANSACTION_TRADE",
          text: "ترید"
        },
        {
          value: "CRYPTO_TRANSACTION_TRADE",
          text: "ترید و تراکنش رمزارز"
        },
        {
          value: "CRYPTO_TRANSACTION",
          text: "تراکنش رمزارز"
        },
        {
          value: "TOMAN_TRANSACTION",
          text: "تراکنش تومان"
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(async () => {
      await this.fetchData();
    })
  },

  components: {
    BasePagination
  },

  computed: {
    showNext() {
      if (this.filters.page_number === 0) {
        if (this.items.length < this.filters.perPage) {
          return false;
        } else {
          return true;
        }
      } else {
        if (
          this.items.length < this.filters.perPage ||
          this.items.length === 0
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
  },

  methods: {
    handlePaginationClick(value) {
      if (value === -1) {
        if (this.filters.page_number > 0) {
          this.filters.page_number--;
          this.fetchData();
        }
      } else if (value === 1) {
        this.filters.page_number++;
        this.fetchData();
      }
    },

    async fetchData() {
      this.loading = true;
      fetchRewardConditions(this.filters)
        .then(res => {
          this.loading = false;
          this.items = res.data.data.map(item=>{
            return {
              ...item,
              type:(this.typeOptions.find(i=>i.value === item.type) || {}).text,
              done_type:(this.actionTypeOptions.find(i=>i.value === item.done_type) || {}).text,
              repeat : item.repeat ? 'دارد'  : 'ندارد',
            }
          });
        })
        .catch(e => {
          console.log(e)
        });
    },
  },
}
</script>

<style lang="scss">
.appbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &__title {
    font-size: 24px;
  }
}


.reward-status-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: #ccc;
  padding: 5px;
  width: 100px;
  margin: auto;
}

.reward-status-chip.active {
  color: white;
  background-color: #2dce89;
}

.reward-status-chip.inactive {
  color: white;
  background-color: #f45656;
}

.filters-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 15px;
  background-color: #eee;
  border-radius: 5px;

  .title {
    display: flex;
    min-width: 150px;

  }

  .filters {
    width: 100%;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;

  }

  .actions {
    display: flex;

  }
}
</style>
